module.exports = __webpack_public_path__ + "img/logo-bold.3ca2c0b4.png";